import React, { useContext, useEffect } from 'react';
import LandingFooter from '../components/landing/Footer';
import LandingMain from '../components/landing/Main';
import LandingNavbar from '../components/landing/Navbar';
import Login from '../components/Login';
import { ToastContainer } from 'react-toastify';
import { GlobalContext } from '../context/GlobalContext';
import 'react-toastify/dist/ReactToastify.css';
import JobDetail from '../components/landing/JobDetail';
import Register from '../components/Register';
import Cookies from 'js-cookie';
import { Navigate } from 'react-router-dom';

function LandingPage(props) {
    const { state } = useContext(GlobalContext);
    const { setUserData } = state;

    useEffect(() => {
        if (Cookies.get('userData')) {
            const data = Cookies.get('userData');
            setUserData(JSON.parse(data));
        }
    }, [setUserData]);

    return (
        <>
            <ToastContainer />
            {props.Login && (
                <div>
                    <LandingNavbar Login />
                    <Login />
                </div>
            )}
            {props.Home && (
                <div>
                    <LandingNavbar />
                    <LandingMain />
                </div>
            )}
            {props.Detail && (
                <div>
                    <LandingNavbar />
                    <JobDetail />
                </div>
            )}
            {props.Register && (
                <div>
                    {Cookies.get('token') ? (
                        <Navigate to={'/'} />
                    ) : (
                        <div>
                            <LandingNavbar />
                            <Register />
                        </div>
                    )}
                </div>
            )}
            <LandingFooter />
        </>
    );
}

export default LandingPage;
